var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-list-direct-chat',{ref:"userListRefs",attrs:{"listUser":_vm.userOpts,"roomId":_vm.roomId},on:{"searchUser":_vm.searchUser,"loadMoreUser":_vm.loadMoreUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }